import { defineMessages } from 'react-intl';

export default defineMessages({
    maxFilesCountError: {
        id: 'adac.documents-upload.You have reached the maximum amount of 10 uploaded documents',
        defaultMessage: 'You have reached the maximum amount of 10 uploaded documents'
    },
    failedUploadDocuments: {
        id: 'adac.documents-upload.Failed to upload documents',
        defaultMessage: 'Failed to upload: \n{ documentArray } \nPlease try again later or sent the documents to the email address ambulance@adac.de giving the claim number in the message title.'
    },
    chooseDocumentType: {
        id: 'adac.documents-upload.Choose the document type',
        defaultMessage: 'Choose the document type'
    },
    chooseFromTheList: {
        id: 'adac.documents-upload.Choose from the list',
        defaultMessage: 'Choose from the list'
    },
    uploadDocument: {
        id: 'adac.documents-upload.Upload document',
        defaultMessage: 'Upload document'
    },
    cancelButton: {
        id: 'adac.documents-upload.Cancel',
        defaultMessage: 'Cancel'
    },
    documentName: {
        id: 'adac.documents-upload.Name',
        defaultMessage: 'Name'
    },
    documentType: {
        id: 'adac.documents-upload.Document type',
        defaultMessage: 'Document type'
    },
    removeDocument: {
        id: 'adac.documents-upload.Remove',
        defaultMessage: 'Remove'
    },
    staticInfo: {
        id: 'adac.documents-upload.You can upload multiple documents. To add another document choose its type first',
        defaultMessage: 'You can upload multiple documents. To add another document choose its type first'
    },
    failedUploadDocumentsFileFormat: {
        id: 'claim.views.claim-documents.Failed to upload. Unsupported file format',
        defaultMessage: 'Failed to upload: \n{ documentArray } \nUnsupported file format'
    },
    failedUploadDocumentsMaxSize: {
        id: 'claim.views.claim-documents.The file exceeds maximum allowed upload size of MB',
        defaultMessage: 'The file exceeds maximum allowed upload size of {size} MB'
    }
});
